export default __webpack_public_path__ + "images/W5.cd60475.png";